<script lang="ts">
    import { onMount } from 'svelte';
    import { createEventDispatcher } from 'svelte';
    import TitleMenu from '../../../components/ui/menu/components/title-menu.svelte';
    import ModalChooseButton from '../../buttons/modal-choose-button.svelte';
    import { trackEvent } from '../../../utils/init-analytics.js';
    import BadgePopular from '../../../components/ui/badges/badge-popular.svelte';

    export let betSizeOptions = [];
    export let selectedValue;
    export let selectedBetIndex;
    export let balance;
    export let currency;
    export let popularBetValue;

    const dispatch = createEventDispatcher();

    onMount(() => {
        trackEvent('click_change_bet_amount', {
            balance,
            currency
        });
    });

    const selectBetAmount = newBetAmountValue => {
        if (selectedValue !== newBetAmountValue) {
            trackEvent('change_bet_amount', {
                balance,
                currency,
                amount: newBetAmountValue,
                change_type: 'MODAL'
            });
        }
        dispatch('change-bet-amount', newBetAmountValue);
    };

    const selectBetIndex = newBetIndex => dispatch('change-bet-index', newBetIndex);
</script>

<TitleMenu class="!mb-6 text-center !text-2xl tablet:!text-4xl">Bet amount</TitleMenu>

{#if selectedValue}
    <div class="mb-6 flex justify-center text-cross-t-body">
        Your current bet is {currency}
        {selectedValue}
    </div>
{/if}

<div class="mx-auto grid max-w-[560px] grid-cols-3 gap-2 desktop:gap-4">
    {#each betSizeOptions as betAmountValue, index}
        <ModalChooseButton
            value={betAmountValue}
            selectedValue={index === selectedBetIndex}
            class={popularBetValue === index && 'col-span-2'}
            on:click={() => {
                selectBetAmount(betAmountValue);
                selectBetIndex(index);
            }}
        >
            {#if popularBetValue === index}
                <BadgePopular />
            {/if}
            {betAmountValue}
        </ModalChooseButton>
    {/each}
</div>
